{
  "id": "campaign-086",
  "name": "Mossy Grounds",
  "seed": "campaign:86",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....L__L....",
    ".....__.....",
    ".i.i.__~i.i,",
    ".....__.~.,,",
    "....h__x.q.,",
    "..q..__.....",
    "....L__i..i.",
    "____________",
    ".%%.L__.....",
    ".%...__.T..T",
    ".....__.....",
    ".i.i.__.i.i.",
    "..,*.__.*..,",
    ".,,,.__...#.",
    "........x..,",
    "S..........."
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 9,
      "y": 0
    },
    {
      "kind": "squirrel",
      "x": 2,
      "y": 1
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 4
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 6
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 8,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 5
    }
  ],
  "generatorVersion": 3,
  "level": 86,
  "biome": "cemetery",
  "par": {
    "reel": 6460,
    "push": 5231,
    "selfPropelled": 4500,
    "tractor": 3760,
    "zeroTurn": 3238,
    "fairway": 2462
  },
  "routeTries": {
    "par": {
      "reel": 16,
      "push": 12,
      "selfPropelled": 12,
      "tractor": 0,
      "zeroTurn": 14,
      "fairway": 17
    }
  }
}
